import { useState, useEffect } from 'react';

import { APP_SETTINGS } from '@constants/constants';
import { AppEnvironment, AppTenant } from '@customTypes/app';

const STORAGE_KEY = 'openreplay-debug-visual-styles-enabled';
const BODY_CLASS = 'openreplay-debug-enabled';
const DEFAULT_ENABLED = false;

const DEBUG_ALLOWED_ENVIRONMENTS: AppEnvironment[] = [
  AppEnvironment.LOCAL,
  AppEnvironment.DEV,
  AppEnvironment.TEST,
  AppEnvironment.STAGING,
];

/** True when OpenReplay debug toggle is available (Myome tenant, non-prod/non-sandbox). */
const isDebugSupported =
  APP_SETTINGS.tenant === AppTenant.MYOME && DEBUG_ALLOWED_ENVIRONMENTS.includes(APP_SETTINGS.environment);

export function useOpenReplayDebugToggle() {
  const [isEnabled, setIsEnabled] = useState<boolean>(() => {
    if (!isDebugSupported || typeof window === 'undefined') return DEFAULT_ENABLED;
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? stored === 'true' : DEFAULT_ENABLED;
  });

  useEffect(() => {
    if (!isDebugSupported) return;

    localStorage.setItem(STORAGE_KEY, String(isEnabled));
    document.body.classList.toggle(BODY_CLASS, isEnabled);
  }, [isEnabled]);

  const toggle = isDebugSupported ? () => setIsEnabled(prev => !prev) : undefined;

  return {
    isEnabled: isDebugSupported ? isEnabled : false,
    toggle,
    isDebugSupported,
  };
}
